import { Reveal } from "@/components/shared/Reveal";
import { Container, SectionLabel } from "@/components/shared/Primitives";
import { RadarRings } from "@/components/shared/Decorations";
import { tint } from "@/data/site";

export default function Terms() {
  return (
    <div>
      {/* HERO */}
      <section className="relative overflow-hidden">
        <div className="pointer-events-none absolute -left-44 -top-36 h-[600px] w-[600px] opacity-50" style={{ color: "var(--page-accent)" }}>
          <RadarRings className="h-full w-full" />
        </div>
        <Container className="relative z-10 pb-14 pt-16 lg:pt-24">
          <Reveal>
            <h1 className="font-display mt-7" style={{ fontSize: "clamp(42px, 7vw, 96px)", lineHeight: 0.9, letterSpacing: "0.02em", color: "var(--text-0)" }}>
              Terms of Service
            </h1>
          </Reveal>
          <Reveal delay={0.08}>
            <p className="mt-5 text-[14px]" style={{ color: "var(--text-3)" }}>
              Last updated: June 2025
            </p>
          </Reveal>
        </Container>
      </section>

      {/* BODY */}
      <section className="pb-20 lg:pb-28">
        <Container>
          <div className="mx-auto max-w-[720px] space-y-8 text-[15px] leading-relaxed" style={{ color: "var(--text-1)" }}>
            <Reveal>
              <p>
                These Terms of Service (&quot;Terms&quot;) govern your use of the Emailink Studio website at{" "}
                <a href="https://emailink.studio" className="underline transition-colors hover:text-[color:var(--text-0)]" style={{ color: "var(--page-accent)" }}>
                  emailink.studio
                </a>{" "}
                and any services, applications, or products offered by Emailink Studio (&quot;we,&quot; &quot;our,&quot; or &quot;us&quot;).
                By using our website or services, you agree to these Terms.
              </p>
            </Reveal>

            <Reveal delay={0.04}>
              <h2 className="text-lg font-semibold" style={{ color: "var(--text-0)" }}>1. Services Description</h2>
              <p>
                Emailink Studio provides email marketing agency services, software applications, and related
                consulting. The specific scope, deliverables, and timelines for agency services are outlined
                in a separate agreement or statement of work provided to the client.
              </p>
            </Reveal>

            <Reveal delay={0.04}>
              <h2 className="text-lg font-semibold" style={{ color: "var(--text-0)" }}>2. Payment Terms</h2>
              <p>
                Payment terms for agency services are specified in the applicable agreement. Unless otherwise
                agreed in writing, payments are due upon receipt of invoice. Late payments may result in
                suspension of services.
              </p>
              <p className="mt-2">
                For one-time purchases (such as the AI Tools Assessment), payment is due at the time of booking.
                Refund policies for specific products are disclosed at the point of sale.
              </p>
            </Reveal>

            <Reveal delay={0.04}>
              <h2 className="text-lg font-semibold" style={{ color: "var(--text-0)" }}>3. Intellectual Property</h2>
              <p>
                Upon full payment, clients retain ownership of all custom work product created specifically for
                them. Emailink Studio retains the right to display completed work in our portfolio unless
                otherwise agreed in a separate non-disclosure agreement.
              </p>
              <p className="mt-2">
                All software, tools, templates, and frameworks developed by Emailink Studio remain our
                intellectual property unless explicitly transferred in writing.
              </p>
            </Reveal>

            <Reveal delay={0.04}>
              <h2 className="text-lg font-semibold" style={{ color: "var(--text-0)" }}>4. Limitation of Liability</h2>
              <p>
                To the maximum extent permitted by law, Emailink Studio shall not be liable for any indirect,
                incidental, special, consequential, or punitive damages arising out of or related to our
                services, including but not limited to lost profits, lost data, or business interruption.
              </p>
              <p className="mt-2">
                Our total liability for any claim arising from our services shall not exceed the amount paid
                by the client for the specific service giving rise to the claim.
              </p>
            </Reveal>

            <Reveal delay={0.04}>
              <h2 className="text-lg font-semibold" style={{ color: "var(--text-0)" }}>5. Confidentiality</h2>
              <p>
                We treat all client information shared during the course of our engagement as confidential.
                We will not disclose your confidential information to third parties except as necessary to
                perform our services or as required by law.
              </p>
            </Reveal>

            <Reveal delay={0.04}>
              <h2 className="text-lg font-semibold" style={{ color: "var(--text-0)" }}>6. Termination</h2>
              <p>
                Either party may terminate an agency engagement as specified in the applicable agreement.
                Upon termination, the client shall pay for all services rendered up to the termination date.
                Any provisions intended to survive termination (including confidentiality, intellectual
                property, and limitation of liability) shall remain in effect.
              </p>
            </Reveal>

            <Reveal delay={0.04}>
              <h2 className="text-lg font-semibold" style={{ color: "var(--text-0)" }}>7. Governing Law</h2>
              <p>
                These Terms shall be governed by and construed in accordance with the laws of the State of
                Florida, without regard to its conflict of law principles. Any disputes arising from these
                Terms shall be resolved in the courts of Pinellas County, Florida.
              </p>
            </Reveal>

            <Reveal delay={0.04}>
              <h2 className="text-lg font-semibold" style={{ color: "var(--text-0)" }}>8. Contact</h2>
              <p>
                Emailink Studio<br />
                7901 4th St N STE 300<br />
                St. Petersburg, FL 33702, USA<br />
                Email:{" "}
                <a href="mailto:jordan@emailink.io" className="underline transition-colors hover:text-[color:var(--text-0)]" style={{ color: "var(--page-accent)" }}>
                  jordan@emailink.io
                </a>
              </p>
            </Reveal>
          </div>
        </Container>
      </section>
    </div>
  );
}
